import { UserServiceClient } from 'fitbeat.api-clients';
import { ITargetInfo, UserTargetTypes } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { closeRemoveTargetModal, confirmRemoveTarget } from './actions';
import { getTargetInfo, isRemovingTargetSelector } from './selectors';
import { Button, ButtonTypes } from '../components';
import { getApiConfig } from '../config';
import { GoogleAnalytics } from '../services/google-analytics';
import Theme from '../theme';
import { UserDataConsumer } from '../utils';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { defaultScale } from '../utils/scaling';

interface IProps {
  target: ITargetInfo;
  t: any;
  isLoading: boolean;
  removeTarget: () => void;
  doNotRemoveTarget: () => void;
}

const RemoveTargetModalComponent: FunctionComponent<IProps> = ({t, target, isLoading, removeTarget, doNotRemoveTarget}) => {
  const header = new Map([
    [UserTargetTypes.Musclemass, t('weightTarget:confirmRemoveTarget', {metric: 'muscle mass'})],
    [UserTargetTypes.Bodyweight, t('weightTarget:confirmRemoveTarget', {metric: 'bodyweight'})],
    [UserTargetTypes.Bodyfat, t('weightTarget:confirmRemoveTarget', {metric: 'body fat'})],
  ]).get(target.targetType!)

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.header}>{header}</Text>
      </View>
      <View>
        <Button title={t('yes')} fontColor={Theme.WHITE} containerStyle={styles.removeScale}
          onPress={removeTarget}
          isLoading={isLoading}
        />
        <Button
          title={t('no')}
          fontColor={Theme.PRIMARY}
          buttonType={ButtonTypes.OUTLINE}
          onPress={doNotRemoveTarget}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    marginHorizontal: defaultScale(15),
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  header: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
  },
  removeScale: {
    marginBottom: defaultScale(14),
  },
});

const mapStateToProps = (state: any) => {
  return {
    target: getTargetInfo(state),
    isLoading: isRemovingTargetSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);

  return {
    removeTarget: () => dispatch(confirmRemoveTarget(userServiceClient)),
    doNotRemoveTarget: () => dispatch(closeRemoveTargetModal())
  };
};

export const RemoveTargetModal = translate(['weightTarget'], { wait: true })(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(RemoveTargetModalComponent)),
);
